import { render, staticRenderFns } from "./NewMapCollectionPage.vue?vue&type=template&id=9cbbdc2a&"
import script from "./NewMapCollectionPage.vue?vue&type=script&lang=js&"
export * from "./NewMapCollectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports